import React, { useContext, useEffect, useState } from "react";

import ViewProject from "./ViewProject";

const ViewProjectEdit = () => {
  return <ViewProject type = "Edit"/>
};

export default ViewProjectEdit;
